"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseDeleteDirection = UseDeleteDirection;
const react_1 = require("react");
const yup_1 = require("@hookform/resolvers/yup");
const react_2 = require("react");
const react_hook_form_1 = require("react-hook-form");
const sweetalert2_1 = __importDefault(require("sweetalert2"));
const yup = __importStar(require("yup"));
const theme_1 = require("../../../../utils/theme");
const Utils_1 = require("../../../../utils/Utils");
const direction_api_1 = require("../../../../utils/api/direction/direction.api");
const hook_1 = require("../../../../redux/hook");
const UseCrudDirection = (handleClose, direction) => {
    const validationSchema = yup.object().shape({
        from: yup.string().required("Le début est requis.").label("De"),
        to: yup.string().required("La fin est requis.").label("À"),
    });
    const { user } = (0, hook_1.useAppSelector)((state) => state.user);
    const { register, handleSubmit, formState: { errors }, setValue, clearErrors, reset, setError, } = (0, react_hook_form_1.useForm)({
        resolver: (0, yup_1.yupResolver)(validationSchema),
        defaultValues: {
            added_by: user.user_id,
        },
    });
    const [from, setFrom] = (0, react_1.useState)(null);
    const [to, setTo] = (0, react_1.useState)(null);
    const fromOptions = [
        {
            label: "DAKAR",
            value: "DAKAR",
        },
        {
            label: "THIES",
            value: "THIES",
        },
        {
            label: "THIES-DAKAR",
            value: "THIES-DAKAR",
        },
    ];
    const toOptions = [
        {
            label: "THIES",
            value: "THIES",
        },
        {
            label: "DAKAR",
            value: "DAKAR",
        },
        {
            label: "DAKAR-THIES",
            value: "DAKAR-THIES",
        },
    ];
    const handleFromChange = (from) => {
        setFrom(from);
        setValue("from", from === null || from === void 0 ? void 0 : from.value);
    };
    const handleToChange = (to) => {
        setTo(to);
        setValue("to", to === null || to === void 0 ? void 0 : to.value);
    };
    const [addOrUpdateDirection, { isLoading, isSuccess, error, isError }] = (0, direction_api_1.useAddOrUpdateDirectionMutation)();
    (0, react_2.useEffect)(() => {
        var _a, _b;
        if (isSuccess) {
            sweetalert2_1.default.fire({
                icon: "success",
                title: `Direction ${direction ? "modifiée" : "ajoutée"} avec succès!`,
                iconColor: theme_1.Color.success,
                showConfirmButton: false,
                timer: 1200,
            }).then(() => {
                if (!direction) {
                    reset();
                }
                handleClose();
            });
        }
        const err = error;
        if (isError) {
            sweetalert2_1.default.fire({
                icon: "error",
                title: ((_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.message)
                    ? (_b = err === null || err === void 0 ? void 0 : err.data) === null || _b === void 0 ? void 0 : _b.message
                    : `Erreur de statut ${err === null || err === void 0 ? void 0 : err.status}`,
                showConfirmButton: false,
                timer: 5000,
            });
        }
    }, [isLoading]);
    (0, react_2.useEffect)(() => {
        (0, Utils_1.cleannerError)(errors, clearErrors);
    }, [errors, clearErrors]);
    const onSubmit = (0, react_1.useCallback)((data) => {
        const { from, to } = data;
        if (direction === null || direction === void 0 ? void 0 : direction.id) {
            data["_method"] = "PUT";
        }
        let key = "";
        if ((from === null || from === void 0 ? void 0 : from.toLowerCase()) === (to === null || to === void 0 ? void 0 : to.toLowerCase())) {
            return setError("from", {
                message: "Les champs renseignés doivent être différents",
            });
        }
        if ((from === null || from === void 0 ? void 0 : from.toLowerCase()) === "DAKAR" &&
            (to === null || to === void 0 ? void 0 : to.toLowerCase()) === "THIES") {
            key = "DKTH";
        }
        else if ((from === null || from === void 0 ? void 0 : from.toLowerCase()) === "THIES" &&
            (to === null || to === void 0 ? void 0 : to.toLowerCase()) === "DAKAR") {
            key = "THDK";
        }
        else {
            key = "ALL";
        }
        const payload = Object.assign(Object.assign({}, data), { key });
        addOrUpdateDirection({ id: direction === null || direction === void 0 ? void 0 : direction.id, data: payload });
    }, [direction === null || direction === void 0 ? void 0 : direction.id, addOrUpdateDirection]);
    (0, react_2.useEffect)(() => {
        if (direction === null || direction === void 0 ? void 0 : direction.id) {
            let fields = ["from", "to"];
            for (let field of fields) {
                register(field);
                setValue(field, direction[field]);
            }
            if (direction === null || direction === void 0 ? void 0 : direction.from) {
                setFrom((direction === null || direction === void 0 ? void 0 : direction.from) || "");
            }
            if (direction === null || direction === void 0 ? void 0 : direction.to) {
                setTo((direction === null || direction === void 0 ? void 0 : direction.to) || "");
            }
        }
    }, [direction]);
    return {
        register,
        errors: errors,
        onSubmit: handleSubmit(onSubmit),
        setValue,
        isLoading,
        reset,
        fromOptions,
        setFrom,
        from,
        handleFromChange,
        toOptions,
        setTo,
        to,
        handleToChange,
    };
};
exports.default = UseCrudDirection;
function UseDeleteDirection(id) {
    const [deleteData] = (0, direction_api_1.useDeleteDirectionMutation)();
    const onDelete = () => __awaiter(this, void 0, void 0, function* () {
        yield sweetalert2_1.default.fire({
            title: `Êtes-vous sûr de vouloir supprimer cette direction ?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "OUI",
            cancelButtonText: "NON",
            showLoaderOnConfirm: true,
            iconColor: theme_1.Color.themeColor,
            confirmButtonColor: theme_1.Color.themeColor,
            preConfirm: () => {
                return deleteData(id);
            },
            allowOutsideClick: () => !sweetalert2_1.default.isLoading(),
        }).then((result) => {
            if (result === null || result === void 0 ? void 0 : result.value) {
                sweetalert2_1.default.fire({
                    icon: "success",
                    title: `Direction supprimée avec succès!`,
                    iconColor: theme_1.Color.themeColor,
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        });
    });
    return onDelete;
}
